import { render, staticRenderFns } from "./Explanation5.vue?vue&type=template&id=6ed13ea4&scoped=true&lang=pug&"
import script from "./Explanation5.vue?vue&type=script&lang=ts&"
export * from "./Explanation5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed13ea4",
  null
  
)

export default component.exports